import { Grid, makeStyles } from '@material-ui/core'
import React from 'react'
import CardWithChart from './CardWithChart'
import CardWithData from './CardWithData'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F5F8FF',
    justifyContent: 'center',
    border: 'none',
    borderRadius: '12px',
    // boxShadow:'none'
  },
  icon: {
    width: '22px',
    height: '22px',
    cursor: 'pointer',
    marginLeft: '22px',
    // marginTop: '4px',
  },
  icons: {
    marginLeft: '20px',
    cursor: 'pointer',
  },

  subtitle: {
    fontSize: '28px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    lineHeight: ' 38px',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
  },
  title1: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '19px',
    letter: '0.5px',
    margin: 5,
    color: '#313131',
    paddingBottom: '43px',
  },

  title2: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    margin: 5,

    color: '#313131',
  },
  title3: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',

    color: '#313131',
    paddingBottom: '10px',
  },
  title4: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '19px',
    letter: '0.5px',
    margin: 5,
    color: '#313131',
    paddingBottom: '9px',
  },
  image: {
    // borderRadius: '45%',
    // height: '9%',
    width: '45px',
    height: '45px',
  },
  underline: {
    borderTop: '1px solid  #CCCCCC',
  },
  drop: {
    width: '70px',
    backgroundColor: 'white',
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
  },
  scrollBar: {
    height: '465px',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: '0.2em',
      borderRadius: '2px',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'slategrey',
      // outline: '1px solid slategrey',
    },
  },
  absentEmployeesClass: {
    height: '100%',
  },
  root2: {
    height: '213px',
    backgroundColor: '#F5F8FF',
    justifyContent: 'center',
    border: 'none',
    borderRadius: '12px',
  },
  layout: {
    padding: '0px 14px 20px 4px',
  },
  padding: {
    padding: '21%',
    textAlign: 'center',
  },
}))

export default function CommonDashboardLayout({ array, lineChart, piechart1, piechart2, employeeList, heading1, heading2, heading3 }) {
  const classes = useStyles()
  return (
    <Grid container className={classes.layout}>
      {array.map((item, index) => (
        <Grid item lg={3} key={index} style={{ flexBasis: '20%' }}>
          <CardWithData heading={item.heading} label={item.label} />
        </Grid>
      ))}

      <Grid item lg={5} style={{ flexWrap: 'wrap' }}>
        <CardWithChart heading={heading1} className>
          {lineChart}
        </CardWithChart>
      </Grid>

      <Grid item lg={4}>
        <CardWithChart heading={heading2}>{piechart1 === 'No Data Found' ? <div className={classes.padding}>{piechart1}</div> : piechart1}</CardWithChart>
        <CardWithChart heading={heading3}>{piechart2}</CardWithChart>
      </Grid>
      <Grid item lg={3} style={{ flexWrap: 'wrap' }}>
        <div className={classes.scrollBar}>{employeeList}</div>
      </Grid>
    </Grid>
  )
}
